// extracted by mini-css-extract-plugin
module.exports = {"tabs":"dmbc-base_tabs-tabs","center":"dmbc-base_tabs-center","custom":"dmbc-base_tabs-custom","fixedTabs":"dmbc-base_tabs-fixedTabs"};